<template>
  <v-row>
    <v-col md="8">
      <div class="map-wrap">
        <google-map :zoom="range.zoom" :paths="range.paths" :stations="stations" :options="{ showSiteStatusColor: true }" :center="range.position"></google-map>
      </div>
    </v-col>
    <v-col md="4">
      <site-status :data="siteInfo"></site-status>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import SiteStatus from '@/components/SiteStatus'
import { FAKE_SITE_INFO } from '@/libs/fakeData'

export default {
  components: { SiteStatus, GoogleMap },
  data () {
    return {
      siteInfo: FAKE_SITE_INFO
    }
  },
  computed: {
    ...mapGetters({
      stations: 'station/list',
      range: 'range/data'
    })
  }
}
</script>
